<template>
  <div
    class="outer-container"
    @click="goBackClick">
    <div class="title-project">Redes2025</div>
    <div
      class="container"
      @click="containerClick">
      <flickity
        :options="flickityOptions">
        <div class="carousel-cell"><img src="@/assets/images/rede-2025-01.jpg"></div>
        <div class="carousel-cell"><img src="@/assets/images/rede-2025-02.jpg"></div>
        <div class="carousel-cell"><img src="@/assets/images/rede-2025-03.jpg"></div>
        <div class="carousel-cell"><img src="@/assets/images/rede-2025-04.jpg"></div>
        <div class="carousel-cell text-cell"><div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed libero enim. Phasellus at purus velit. Aliquam vel sagittis ex, vitae ultricies neque. Nulla a lacus volutpat diam convallis venenatis. Etiam posuere at eros quis egestas. Cras sollicitudin sollicitudin convallis. Sed gravida, dolor tristique maximus imperdiet, sapien justo commodo sem, non convallis massa purus in augue. Phasellus pulvinar consequat mi, vitae pharetra purus vestibulum vel. Nullam ullamcorper, tortor at faucibus pretium, leo mauris vehicula felis, ac finibus leo tortor eleifend augue. Cras vel sapien nec odio maximus molestie.</p>
          <p>Curabitur eu mattis lacus. Vestibulum aliquam lacinia dolor, fringilla ultricies est mollis non. Vivamus ullamcorper lectus in ante placerat tincidunt. Nunc consequat scelerisque enim, eget laoreet turpis aliquet at. Ut pretium sodales augue, id auctor mi ultricies quis. Quisque pellentesque tempus ante ac pharetra. Phasellus ultricies, nibh non ultrices accumsan, urna risus laoreet ligula, in tempor elit ante non mi. Ut maximus dolor felis, id sodales lectus elementum tempor. Nulla vitae congue ex. Pellentesque sit amet tortor suscipit, rutrum ligula eu, euismod dui. Nulla sagittis eleifend aliquet. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Sed sed nunc sem. Sed sollicitudin tincidunt pretium.</p>
          <p>Sed quis ligula pulvinar, suscipit metus sed, vulputate neque. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pulvinar ac magna id feugiat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam venenatis purus nec tristique pharetra. Maecenas tortor diam, placerat a ex et, vestibulum consequat libero. Ut eu metus non lectus bibendum auctor nec ut elit. Phasellus euismod interdum eros, id interdum libero. Mauris dapibus nunc est. Maecenas in ipsum in enim gravida tincidunt at eget justo. Sed sodales magna et ligula eleifend, quis congue leo ullamcorper. Integer eu ligula congue, pulvinar diam vitae, volutpat augue. Sed pharetra in urna et facilisis. Curabitur consequat sed tellus ut eleifend. In vehicula nulla et justo malesuada auctor.</p>
        </div></div>
      </flickity>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity';

export default {
  name: 'Redes2025',
  components: {
    Flickity
  },
  data() {
    return {
      flickityOptions: {
        pageDots: false,
        setGallerySize: false
      }
    };
  },
  methods: {
    goBackClick: function() {
      this.$router.go(-1);
    },
    containerClick: function(a) {
      a.preventDefault();
      a.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/colors';
.outer-container {
  display: flex;
  background-color: $dawn_pink;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  overflow: auto;
  font-family: 'TSTAR PRO';
}
.container {
  position: absolute;
  right: 16vw;
  left: 16vw;
  top: 8vw;
  bottom: 8vw;
  & > div {
    height: 100%;
  }
  overflow: hidden;
}
.carousel-cell {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    display: block;
    max-height: 100%;
  }
  &.text-cell {
    background-color: $dawn_pink;
    align-items: baseline;
    overflow: auto;
    & > div {
      font-size: 1.3vw;
      padding-left: 14vw;
      line-height: 1.3em;
    }
  }
  overflow: hidden;
}
</style>
